import SanjivAgarwal from '../../images/ourteam/SanjivAgarwal.jpg'
import RajivAgarwal from '../../images/ourteam/RajivAgarwal.jpg'
import GazanfarIbrahim from '../../images/ourteam/GazanfarIbrahim.jpg'
import VasudevanSuresh from '../../images/ourteam/VasudevanSuresh.jpg'
import AakashVerma from '../../images/ourteam/AakashVerma.jpg'
import BhavikVora from '../../images/ourteam/BhavikVora.jpg'
import HarshAgarwal from '../../images/ourteam/HarshAgarwal.jpg'
import MdTariqueEbrahim from '../../images/ourteam/MdTariqueEbrahim.jpg'
import RajKapoorSingh from '../../images/ourteam/RajKapoorSingh.jpg'
import RamanMahesh from '../../images/ourteam/RamanMahesh.jpg'
import SandrineClarac from '../../images/ourteam/SandrineClarac.jpg'
import UmangAgarwal from '../../images/ourteam/UmangAgarwal.jpg'
import RajarshiDe from '../../images/ourteam/RajarshiDe.jpg'
import Cristina from '../../images/ourteam/Cristina.jpg'
import JavierPalencia from '../../images/ourteam/JavierPalencia.jpg'
import SimonPress from '../../images/ourteam/SimonPress.png'
import DefaultUser from '../../images/ourteam/User.jpeg'
import SandeepRangroo from '../../images/ourteam/SandeepRangroo.jpg'
import ShitijMalhotra from '../../images/ourteam/ShitijMalhotra.jpg'

const teamMembersRaw = [
      {
        id: 'sanjiv-agarwal',
        name: 'Sanjiv Agarwal',
        desi: 'Founder & CEO',
        image: SanjivAgarwal,
        url: "https://www.linkedin.com/in/sanjiv-agarwal-53b805b9",
        regions: ['ALL','GLOBAL'],
      },
      {
        id: 'rajiv-agarwal',
        name: 'Rajiv Agarwal',
        desi: 'Managing Director',
        image: RajivAgarwal,
        url: "",
        regions: ['ALL'],
      },
      {
        id: 'gazanfar-ibrahim',
        name: 'Gazanfar Ibrahim',
        desi: 'CMO & MD',
        image: GazanfarIbrahim,
        url: "https://www.linkedin.com/in/gazanfar-ibrahim-86935b21",
        regions: ['ALL'],
      },
      {
        id: 'vasudevan-suresh',
        name: 'Vasudevan Suresh',
        desi: 'President, GGIF',
        image: VasudevanSuresh,
        url: "https://www.linkedin.com/in/suresh-vasudevan-349253157",
        regions: ['ALL'],
      },
      {
        id: 'harsh-agarwal',
        name: 'Harsh Agarwal',
        desi: 'Managing Director - International',
        image: HarshAgarwal,
        url: "https://www.linkedin.com/in/harsh3442",
        regions: ['ALL','GLOBAL'],
      },
      {
        id: 'umang-agarwal',
        name: 'Umang Agarwal',
        desi: 'Executive Director',
        image: UmangAgarwal,
        url: "https://www.linkedin.com/in/umangag",
        regions: ['ALL','GLOBAL'],
      },
      {
        id: 'raj-kapoor-singh',
        name: 'Raj Kapoor Singh',
        desi: 'Director of Sales',
        image: RajKapoorSingh,
        url: "https://www.linkedin.com/in/raj-kapoor-singh-6b428816",
        regions: ['ALL'],
      },
      {
        id: 'sandrine-clarac',
        name: 'Sandrine Clarac',
        desi: 'Group Director',
        image: SandrineClarac,
        url: "https://www.linkedin.com/in/sandrine-clarac",
        regions: ['ALL','GLOBAL'],
      },
      {
        id: 'bhavik-vora',
        name: 'Bhavik Vora',
        desi: 'Director of Finance & Accounting',
        image: BhavikVora,
        url: "https://www.linkedin.com/in/bhavik-vora-ca-acca-dip-in-ifrs-6a93bb53",
        regions: ['ALL'],
      },
      {
        id: 'rajarshi-de',
        name: 'Rajarshi De',
        desi: 'Area Director',
        image: RajarshiDe,
        url: "",
        regions: ['ALL'],
      },
      {
        id: 'raman-mahesh',
        name: 'Raman Mahesh',
        desi: 'Area Director',
        image: RamanMahesh,
        url: "",
        regions: ['ALL'],
      },
      {
        id: 'md-tarique-ebrahim',
        name: 'Md Tarique Ebrahim',
        desi: 'Area Director',
        image: MdTariqueEbrahim,
        url: "https://www.linkedin.com/in/tarique-ebrahim-5654332a",
        regions: ['ALL'],
      },
      {
        id: 'aakash-verma',
        name: 'Aakash Verma',
        desi: 'Area Director',
        image: AakashVerma,
        url: "https://www.linkedin.com/in/aakash-verma-53a272b6",
        regions: ['ALL'],

      },
      {
        id: 'simon-press',
        name: 'Simon Press',
        desi: 'Managing Director — International',
        image: SimonPress,
        url: "https://uk.linkedin.com/in/simon-press-a6270b6",
        regions: ['ALL','GLOBAL'],
      },
      {
        id: 'javier-palencia',
        name: 'Javier P. Palencia',
        desi: 'Director, WTE Miami and Senior Advisor',
        image: JavierPalencia,
        url: "https://www.linkedin.com/in/jppalencia",
        regions: ['ALL','GLOBAL'],
      },
      {
        id: 'cristina-rivadeneira',
        name: 'Cristina Rivadeneira',
        desi: 'WTE Miami',
        image: Cristina,
        url: "",
        regions: ['ALL','GLOBAL'],
      },
      {
        id: 'bryan-juliatti',
        name: 'Bryan Juliatti',
        desi: 'WTE Miami',
        image: DefaultUser,
        url: "https://www.linkedin.com/in/bryanjuliatti/",
        regions: ['ALL','GLOBAL'],
      },
      {
        id: 'sandeep-rangroo',
        name: 'Sandeep Rangroo',
        desi: 'Area Director',
        image: SandeepRangroo,
        url: "https://www.linkedin.com/in/sandeeprangroo",
        regions: ['ALL'],
      },
      {
        id: 'shitij-malhotra',
        name: 'Shitij Malhotra',
        desi: 'Associate Director',
        image: ShitijMalhotra,
        url: "https://www.linkedin.com/in/shitij-malhotra-a51aa51a",
        regions: ['ALL'],
      }
];

export const getTeamByRegion = (region) => {
    return teamMembersRaw.filter(member =>
      member.regions.includes(region)
    );
};
  
export const getAllTeam = () => teamMembersRaw;
  
const TEAM_ORDER = {
    ALL: [
        'sanjiv-agarwal',
        'rajiv-agarwal',
        'gazanfar-ibrahim',
        'vasudevan-suresh',
        'simon-press',
        'harsh-agarwal',
        'umang-agarwal',
        'raj-kapoor-singh',
        'sandrine-clarac',
        'javier-palencia',
        'bhavik-vora',
        'rajarshi-de',
        'raman-mahesh',
        'md-tarique-ebrahim',
        'aakash-verma',
        'sandeep-rangroo',
        'shitij-malhotra',
        'cristina-rivadeneira',
    ],    
    GLOBAL: [
        'sanjiv-agarwal',
        'simon-press',
        'harsh-agarwal',
        'javier-palencia',
        'sandrine-clarac',
        'umang-agarwal',
        'cristina-rivadeneira',
        'bryan-juliatti',
    ],
};

const sortByOrder = (members, region = 'ALL') => {
    const order = TEAM_ORDER[region] || [];

    return [...members].sort((a, b) => {
        const indexA = order.indexOf(a.id);
        const indexB = order.indexOf(b.id);

        // push unknown items to bottom
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;

        return indexA - indexB;
    });
};

export const getTeam = (region = 'ALL') => {
    let members =
        region === 'ALL'
        ? getAllTeam()
        : getTeamByRegion(region);

    return sortByOrder(members, region);
};